import API, { defaultHeaders, IRI } from '@/api';

const fetchDelete = id => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;
  return fetch(`${API}${IRI.exam}${id}`, {
    method: 'DELETE',
    headers
  });
};

export default fetchDelete;
